document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (toggle && nav) toggle.addEventListener('click', () => {
    nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', nav.classList.contains('open'));
  });

  document.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(btn.dataset.target);
      if (!input) return;
      const value = Math.max(1, parseInt(input.value || '1', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1));
      input.value = value;
    });
  });

  const thumbs = document.querySelectorAll('[data-product-thumb]');
  const main = document.querySelector('[data-product-main]');
  thumbs.forEach(t => t.addEventListener('click', () => {
    if (!main) return;
    main.src = t.dataset.src;
    thumbs.forEach(x => x.classList.remove('active'));
    t.classList.add('active');
  }));
});


// Guided franchise/dealership application
const app=document.querySelector('[data-ownership-app]');
if(app){const cards=[...app.querySelectorAll('[data-app-step]')], inds=[...app.querySelectorAll('[data-step-indicator]')], review=app.querySelector('[data-review]');let current=0;
const show=i=>{current=Math.max(0,Math.min(cards.length-1,i));cards.forEach((c,n)=>c.classList.toggle('is-hidden',n!==current));inds.forEach((x,n)=>{x.classList.toggle('is-active',n===current);x.classList.toggle('is-complete',n<current)});window.scrollTo({top:app.offsetTop-20,behavior:'smooth'});if(current===cards.length-1&&review){let out=[];cards.slice(0,-1).forEach(c=>c.querySelectorAll('input:not([type="hidden"]),select,textarea').forEach(e=>{if(e.type==='checkbox'||!e.value.trim())return;let l=c.querySelector('label[for="'+e.id+'"]');out.push('<div class="review-item"><small>'+((l?l.textContent:e.name).replace('*','').trim())+'</small><strong>'+e.value.replace(/</g,'&lt;').replace(/>/g,'&gt;')+'</strong></div>')}));review.innerHTML=out.join('')}};
const valid=()=>{let ok=true;cards[current].querySelectorAll('input,select,textarea').forEach(e=>{if(e.checkValidity&&!e.checkValidity()){e.reportValidity();ok=false}});return ok};
app.querySelectorAll('[data-next]').forEach(b=>b.addEventListener('click',()=>{if(valid())show(current+1)}));app.querySelectorAll('[data-prev]').forEach(b=>b.addEventListener('click',()=>show(current-1)));show(0)}
